// Beds24 authentication mode — DECOUPLED from APP_ENV (§8.141) so a
// deployed dev/sandbox server can run the real InviteCode + Vault flow
// without mislabeling itself "production". The two concerns used to be
// the same flag (`appEnv === "production"`), which forced a dev server
// to lie about its environment just to exercise invite-code onboarding.
//
// Values mirror the `beds24_integrations.auth_kind` column:
//   invite_code — onboarding exchanges a Beds24 invite code → per-org
//                 refresh token in Supabase Vault; token reads come from
//                 Vault (VaultAccessTokenProvider). The go-live path.
//   long_life   — the dev shortcut: one env-wide LongLife token
//                 (EnvLongLifeTokenProvider); the wizard skips the
//                 exchange (ConfigurableBeds24Healthcheck.alwaysOk).
export type Beds24AuthMode = "invite_code" | "long_life";

// Resolve from BEDS24_AUTH_MODE, falling back to the APP_ENV-derived
// default so existing deploys are unchanged: an explicit, valid value
// wins; otherwise `APP_ENV === "production"` → invite_code, anything
// else → long_life. That fallback is the EXACT behaviour the old
// `appEnv === "production"` checks had (note: raw APP_ENV, not the
// runtime profile — a sandbox deploy running `next start` has
// NODE_ENV=production but must stay long_life unless told otherwise).
export function resolveBeds24AuthMode(
  rawAuthMode: string | undefined,
  rawAppEnv: string | undefined,
): Beds24AuthMode {
  const mode = (rawAuthMode ?? "").trim().toLowerCase();
  if (mode === "invite_code" || mode === "long_life") return mode;
  return (rawAppEnv ?? "").trim().toLowerCase() === "production"
    ? "invite_code"
    : "long_life";
}
